import React from 'react';
import TrailResults from './Lists/TrailResults';
import PlaceResults from './Lists/PlaceResults';
import StoryResults from './Lists/StoryResults';
import NoResults from './Lists/NoResults';

type ResultsProps = {
	listKey: string;
	term: string;
};

const ResultsHandler: React.FC<ResultsProps> = ({ listKey, term }) => {
	const renderList = () => {
		if (listKey === 'trails') {
			return <TrailResults term={term} />;
		} else if (listKey === 'places') {
			return <PlaceResults term={term} />;
		} else if (listKey === 'stories') {
			return <StoryResults term={term} />;
		} else {
			return <NoResults />;
		}
	};

	return <>{renderList()}</>;
};

export default ResultsHandler;
